<template>
  <v-container v-if="radio">
    <v-row
      align="center"
    >
      <v-col cols="auto">
        <v-btn
          icon
          :to="{ name: 'radios' }"
          exact
        >
          <v-icon small>
            fas fa-arrow-left
          </v-icon>
        </v-btn>
      </v-col>
      <v-col
        cols="auto"
      >
        <div class="title text-uppercase font-weight-medium">
          {{ radio.title }}
        </div>
      </v-col>
      <v-spacer />
      <v-col
        cols="auto"
        class="body-2"
      >
        Last Update: {{ $dayjs(radio.updated_at).format('DD.MM.YYYY. HH:mm:ss') }}
      </v-col>
      <v-col
        cols="auto"
        class="body-2"
        :class="{ 'error--text': shouldSync }"
      >
        Last Sync: {{ radio.last_sync_at ? $dayjs(radio.last_sync_at).format('DD.MM.YYYY. HH:mm:ss') : 'Never' }}
      </v-col>
      <v-col cols="auto">
        <v-btn
          :color="shouldSync ? 'primary' : undefined"
          :outlined="!shouldSync"
          class="ma-0 mr-2"
          @click="syncPlayers()"
        >
          <v-icon
            left
            small
          >
            fas fa-sync
          </v-icon>
          Sync Players
        </v-btn>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              color="primary"
              class="ma-0"
              v-on="on"
            >
              <v-icon
                left
                small
              >
                fa fa-plus
              </v-icon>
              Add Clock
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="newClock(CONTENT_TYPE_MUSIC)">
              <v-list-item-content>
                <v-list-item-title>
                  Music
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="newClock(CONTENT_TYPE_MARKETING)">
              <v-list-item-content>
                <v-list-item-title>
                  Marketing
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="newClock(CONTENT_TYPE_PA)">
              <v-list-item-content>
                <v-list-item-title>
                  Public Announcement
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              class="ml-2"
              v-on="on"
            >
              <v-icon small>
                fas fa-ellipsis-v
              </v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <!--            <v-list-item>-->
            <!--              <v-list-item-icon>-->
            <!--                <v-icon small>-->
            <!--                  fa fa-cog-->
            <!--                </v-icon>-->
            <!--              </v-list-item-icon>-->
            <!--              <v-list-item-title>-->
            <!--                Settings-->
            <!--              </v-list-item-title>-->
            <!--            </v-list-item>-->
            <v-list-item @click="editRadioDialog.clone = false; editRadioDialog.visible = true">
              <v-list-item-icon>
                <v-icon small>
                  fa fa-pen
                </v-icon>
              </v-list-item-icon>
              <v-list-item-title>Edit Radio</v-list-item-title>
            </v-list-item>
            <v-list-item @click="editRadioDialog.clone = true; editRadioDialog.visible = true">
              <v-list-item-icon>
                <v-icon small>
                  fa fa-clone
                </v-icon>
              </v-list-item-icon>
              <v-list-item-title>Create Child Radio</v-list-item-title>
            </v-list-item>
            <v-list-item @click="editRadioSettingsDialog = true">
              <v-list-item-icon>
                <v-icon small>
                  fa fa-cog
                </v-icon>
              </v-list-item-icon>
              <v-list-item-title>Playback Settings</v-list-item-title>
            </v-list-item>
            <v-divider />
            <v-list-item @click="deleteConfirmationDialogVisible = true">
              <v-list-item-icon>
                <v-icon small>
                  fa fa-trash
                </v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                Delete Radio
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>

    <div
      class="pa-3 caption mb-2 rounded"
      style="border: 1px solid rgba(0, 0, 0, 0.12)"
    >
      <v-row dense>
        <v-col
          v-if="radio.is_child"
          cols="auto"
        >
          <v-chip
            small
            color="secondary"
            dark
            :to="{ name: 'radio', params: { id: radio.parent.id }}"
          >
            Child of
            {{ radio.parent.title }}
            <v-icon
              right
              x-small
            >
              fa fa-external-link-alt
            </v-icon>
          </v-chip>
        </v-col>
        <v-col
          cols="auto"
        >
          <span class="caption">Client:</span>
          <v-chip
            small
            class="ml-1"
          >
            {{ radio.client ? radio.client.name : 'All Clients' }}
          </v-chip>
        </v-col>
      </v-row>
      <div class="pt-2">
        {{ radio.description }}
      </div>
    </div>

    <v-tabs background-color="transparent">
      <v-tab
        class="text-none"
        :to="{ name: 'radio', params: { id: $route.params.id }}"
        exact
      >
        Schedule
      </v-tab>
      <v-tab
        class="text-none"
        :to="{ name: 'radioPlayers', params: { id: $route.params.id }}"
        exact
      >
        Players
      </v-tab>
    </v-tabs>
    <v-divider />
    <v-fade-transition mode="out-in">
      <router-view
        v-if="radio"
        :key="radio.id"
        :radio="radio"
      />
    </v-fade-transition>

    <edit-radio-dialog
      v-if="radio"
      :visible.sync="editRadioDialog.visible"
      :radio="!editRadioDialog.clone ? radio : undefined"
      :parent-radio="editRadioDialog.clone ? radio : undefined"
      @radio:updated="fetchRadio()"
      @radio:deleted="$router.push({ name: 'radios' })"
      @radio:created="$router.push({ name: 'radio', params: { id: $event.id }})"
    />

    <edit-radio-settings-dialog
      v-if="radio"
      :radio="radio"
      :visible.sync="editRadioSettingsDialog"
      @radio:updated="fetchRadio()"
    />

    <confirm-delete-dialog
      :visible.sync="deleteConfirmationDialogVisible"
      :deleting="deleting"
      @confirm="deleteRadio()"
    />
  </v-container>
</template>

<script>
// @ is an alias to /src

import Radios from '@/services/Radios'
import { EventBus } from '@/plugins/bus'
import ClockModel from '@/models/ClockModel'
import EditRadioDialog from '@/components/radio/EditRadioDialog'
import deleteConfirmationMixin from '@/mixins/deleteConfirmationMixin'
import ConfirmDeleteDialog from '@/components/helpers/ConfirmDeleteDialog'
import EditRadioSettingsDialog from '@/components/radio/EditRadioSettingsDialog'

export default {
  name: 'Radio',
  components: {
    EditRadioSettingsDialog,
    ConfirmDeleteDialog,
    EditRadioDialog
  },
  mixins: [deleteConfirmationMixin],
  data() {
    return {
      radio: undefined,
      loading: false,
      clocks: {
        loading: false,
        data: []
      },
      editRadioDialog: {
        visible: false,
        clone: false
      },
      editRadioSettingsDialog: false
    }
  },
  computed: {
    shouldSync() {
      if (!this.radio) return false

      return this.$dayjs(this.radio.last_sync_at).isBefore(this.$dayjs(this.radio.updated_at))
    }
  },
  watch: {
    '$route.params.id': function () {
      this.fetchRadio()
    }
  },
  created() {
    this.CONTENT_TYPE_MUSIC = ClockModel.CONTENT_TYPE_MUSIC
    this.CONTENT_TYPE_MARKETING = ClockModel.CONTENT_TYPE_MARKETING
    this.CONTENT_TYPE_PA = ClockModel.CONTENT_TYPE_PA

    this.fetchRadio()

    this.days = [1, 2, 3, 4, 5, 6, 7]
  },
  methods: {
    async fetchRadio() {
      this.loading = true

      try {
        this.radio = await Radios.get(this.$route.params.id)
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    newClock(type) {
      EventBus.$emit(`new-clock:${type}`)
    },
    async deleteRadio() {
      this.deleting = true

      try {
        await Radios.delete(this.radio.id)

        this.$store.dispatch('alert', {
          text: 'Successfully deleted',
          color: 'success'
        })

        this.$router.push({ name: 'radios' })
      } catch (e) {
        this.$store.dispatch('alert', {
          text: 'Something went wrong',
          color: 'error'
        })
        throw e
      } finally {
        this.deleteConfirmationDialogVisible = false
        this.deleting = false
      }
    },
    async syncPlayers() {
      try {
        await Radios.syncPlayers(this.radio.id)

        this.$store.dispatch('alert', {
          text: 'Sync sent to radio players. All players online will start syncing changes.',
          color: 'success'
        })

        this.fetchRadio()
      } catch (e) {
        this.$store.dispatch('alert', {
          text: 'There was a problem syncing all radio players.',
          color: 'error'
        })

        throw e
      }
    }
  }
}
</script>
